import { State } from './reducer';
import { Product } from '../services/products';
import { getProductShortName, getProductFullName } from '../services/productNames';
import { getSpecsGrouping } from '../services/specGroupings';
import { getDownloadableTemplates } from '../services/downloadableTemplates';
import { getProductDisplayOrderWeight } from '../services/productDisplayOrderWeights';

export function selectProducts(state: State) {
  // we assume that all loadables have loaded if we're selecting on Products
  // the app should not render any components which need Products until all loadables have finished
  // therefore, it is "safe" for us to use the non-null assertion (!) here
  return state.loadableProductShapes.data!.map<Product>(productShape => {
    const upsellPriceHTML = state.loadableUpsellPriceBySKU.data![productShape.sku];
    if (upsellPriceHTML === undefined) {
      throw new Error(`UpsellPrice was not found for ${productShape.sku}`);
    }

    const specs = state.loadableProductSpecsBySKU.data![productShape.sku];
    if (specs === undefined) {
      throw new Error(`ProductSpecs were not found for ${productShape.sku}`);
    }

    return {
      shortName: getProductShortName(productShape.id),
      name: getProductFullName(productShape.id),
      mpId: state.mpId!,
      sku: productShape.sku,
      upsellPriceHTML,
      displayOrderWeight: getProductDisplayOrderWeight(productShape.id),
      specs,
      specsGrouping: getSpecsGrouping(productShape.id),
      baseQuantity: state.loadableBaseOffer.data!.quantity,
      attributeChoices: productShape.attributeChoices,
      downloadableTempates: getDownloadableTemplates(productShape.id),
    };
  });
}
